import v from "./index.es530.js";
import D from "./index.es518.js";
import N from "./index.es520.js";
function m(r) {
  "@babel/helpers - typeof";
  return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, m(r);
}
function B(r, o, u) {
  var p = u.getStyle, S = u.getSharedString, b = u.customFont, g = u.dateFormat, h = u.usesSchema, c = o + 1, a, d = r.map(function(e, w) {
    if (e == null)
      return "";
    var l = e.height, s = D(e), t = e.type, n = e.value, f = e.format;
    if (F(n) ? n = null : t === void 0 && (h || (t = E(n)), t === void 0 && (t = String, n = String(n))), f) {
      if (t !== Date && t !== Number && t !== String && t !== "Formula")
        throw new Error('`format` can only be used on `Date`, `Number`, `String` or `"Formula"` cells');
      if (t === String && f !== "@")
        throw new Error('`String` cells only support "@" `format`');
    } else
      t === Date && (f = g);
    var y;
    return (f || b || s) && (y = p(s || {}, {
      format: f
    })), l && (a === void 0 || a < l) && (a = l), v(c, w, n, t, y, S);
  }).join(""), i = {
    r: c
  };
  return a && (i.ht = a, i.customHeight = 1), "<row".concat(N(i), ">") + d + "</row>";
}
function F(r) {
  return r == null || r === "";
}
function E(r) {
  switch (m(r)) {
    case "string":
      return String;
    case "number":
      return Number;
    case "boolean":
      return Boolean;
    default:
      if (r instanceof Date)
        return Date;
  }
}
export {
  B as default
};
//# sourceMappingURL=index.es516.js.map
